module.exports = __webpack_public_path__ + "static/media/show-less.13d5750c.svg";